import { useContext } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "../../contexts/AuthContext";

import NavbarLink from "../NavbarLink";

import { Bars3Icon, ArrowLeftEndOnRectangleIcon, UserIcon, PencilIcon } from "@heroicons/react/24/outline";
import ASELogo from "../../assets/ase-logo.png";

const PartnerStaffMobileNavOverlay = ({ isOpen, onCloseClicked }) => {
  const { mutateUser, setToken } = useContext(AuthContext);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    mutateUser(null);
  }

  return (
    <nav className={`${isOpen ? 'fixed' : 'hidden'} top-0 left-0 right-0 bottom-0 z-50 bg-white shadow-md md:hidden px-4 py-2`}>
      <div className="flex items-center justify-between mb-8">
        <Link to="/partner">
          <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
        </Link>

        <Bars3Icon
          className='h-8 w-8 text-ase-blue'
          onClick={onCloseClicked}
        />
      </div>

      <div className="flex flex-col gap-2 mb-4">
        <NavbarLink to="/partner-staff" label="Projects" icon={<PencilIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/partner-staff/profile" label="Profile" icon={<UserIcon className="h-8 w-8 text-ase-blue" />} />
      </div>

      <button
        onClick={handleLogout}
        className='bg-red-600 text-white font-semibold h-[36px] rounded-md w-[250px] flex items-center justify-center gap-1 text-sm'
      >
        <ArrowLeftEndOnRectangleIcon className='h-5 w-5' /> Sign out
      </button>
    </nav>
  );
}

export default PartnerStaffMobileNavOverlay;
